'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const get = require('lodash.get');

const copy = require('./DetailsFooter.json');
const { OPEN_DETAILS_FROM_SIDEBAR, OPEN_DETAILS_FROM_DESCRIPTION } = require('../../../constants/shippingConstants');

const styles = require('./DetailsFooter.scss');

function FooterQuoteBlurb(props) {
    const { canRequestShippingQuote, quotes } = props;
    const hasQuotes = !!get(quotes, 'shipmentQuotes', []).length;
    if (canRequestShippingQuote) {
        const { openQuoteRequestModal } = props;
        return (
            <div>
                <div className={hasQuotes ? styles.quoteWrapper : styles.quoteWrapperNoQuotes}>
                    <span className={styles.somewhereElse}>
                        {hasQuotes ? copy.preDisclaimer.canRequestQuote.copy : null}
                        <a data-tn="shipping-request-open-quote-modal" href="#" onClick={openQuoteRequestModal}>
                            {copy.preDisclaimer.canRequestQuote.linkCTA}
                        </a>
                    </span>
                </div>
            </div>
        );
    }
    const { isVerifiedTrade } = props;
    let preDisclaimer = copy.preDisclaimer.standard;
    if (!hasQuotes) {
        preDisclaimer = copy.preDisclaimer.none;
    } else if (isVerifiedTrade) {
        preDisclaimer = copy.preDisclaimer.trade;
    }

    return (
        <div>
            <div className={hasQuotes ? styles.quoteWrapper : styles.quoteWrapperNoQuotes}>
                <span className={styles.somewhereElse}>{preDisclaimer}</span>
                <span>{copy.disclaimer}</span>
            </div>
            {hasQuotes ? null : <div className={styles.noQuotes}></div>}
        </div>
    );
}

FooterQuoteBlurb.propTypes = {
    canRequestShippingQuote: PropTypes.bool,
    isVerifiedTrade: PropTypes.bool,
    quotes: PropTypes.shape({
        shipmentQuotes: PropTypes.array.isRequired
    }).isRequired,
    source: PropTypes.oneOf([OPEN_DETAILS_FROM_SIDEBAR, OPEN_DETAILS_FROM_DESCRIPTION]).isRequired,
    openQuoteRequestModal: PropTypes.func
};

function FooterLegalBlurb() {
    return (
        <div>
            <div className={styles.customsWrapper}>
                {copy.legal}
                <a href={copy.link}>{copy.linkCTA}</a>
            </div>
        </div>
    );
}

module.exports = { FooterLegalBlurb, FooterQuoteBlurb };



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/ShippingDetailsModal/DetailsFooter.jsx